module.exports = __webpack_public_path__ + "static/ncl-qikober-regular-860451e19ae1269a9fd1d449bbb42fcf.woff";